// extracted by mini-css-extract-plugin
module.exports = {"primary":"Title_primary__VfJ9b","secondary":"Title_secondary__a83fT"};